<div class="body-container">
  <div class="page-main">
    <div class="page-container">
      <form *ngIf="isFormReady" novalidate class="form-wrapper">
          <div class="form-content">
              <div class="form-section">
                <div class="form-section-side">
                    <h1 class="label-title">API Key Permission</h1>
                </div>
                <div class="form-section-container section-form-key-permission">
                  <div class="form-section-body">
                    <mat-radio-group class="custom-mat-radio-group column">
                      <mat-radio-button [checked]="true" color="primary" value="1" class="custom-mat-radio-button">
                        <p class="typo body-1 semi-condensed fw500 label-title">Full Access Key</p>
                        <p class="typo caption semi-condensed fw300 label-subtitle">Allows API calls from web browsers. Create new subscriptions, checkout new subscriptions, and more.</p>
                      </mat-radio-button>
                      <mat-radio-button [disabled]="true" color="primary" value="2" class="custom-mat-radio-button">
                        <p class="typo body-1 semi-condensed fw500 label-title">Read-Only Key</p>
                        <p class="typo caption semi-condensed fw300 label-subtitle">Allows read-only access to your to transactional and/or configuration data from Rebillia.</p>
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
          </div>
          <nav class="post-form">
              <button mat-flat-button (click)="onSubmit()" [disabled]="formSubmitted" color="primary" class="custom-mat-button-primary rounded typo uppercase size size1of1">Save Changes</button>
          </nav>
      </form>
      <!-- skeleton form-sections -->
      <div *ngIf="!isFormReady">
        <skeleton-loader-form [top]="true" [numberOfInputs]="5"></skeleton-loader-form>
      </div>
    </div>
  </div>
</div>
